import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Text from 'common/ui/Text';
import { Colors } from 'styles';
import styled from 'styled-components';

export const DialogsTable = styled(TableContainer)`
  border-radius: 8px;
  overflow: hidden;
`;

export const HeaderRow = styled(TableRow)`
  background-color: ${Colors.gray2};
`;

export const HeaderCell = styled(TableCell)`
  padding: 8px 16px;
  border-bottom: 1px solid ${Colors.gray3};
  color: ${Colors.gray10};
`;

export const ToggleHeaderCell = styled(HeaderCell)`
  width: 72px;
  padding-right: 12px;
`;

export const BodyCell = styled(TableCell)`
  padding: 4px 16px;
  border-bottom: 1px solid ${Colors.gray3};
  color: inherit;
`;

export const BodyRow = styled(TableRow)<{ $isVisible: boolean }>`
  background-color: ${Colors.gray1};

  & ${BodyCell} {
    color: ${({ $isVisible }) => ($isVisible ? Colors.gray10 : Colors.gray8)};
    font-style: ${({ $isVisible }) => ($isVisible ? 'normal' : 'italic')};
  }

  & ${BodyCell} ${Text} {
    color: ${({ $isVisible }) => ($isVisible ? Colors.gray10 : Colors.gray8)};
    font-style: ${({ $isVisible }) => ($isVisible ? 'normal' : 'italic')};
  }

  &:last-child ${BodyCell} {
    border-bottom: none;
  }
`;

export const ToggleBodyCell = styled(BodyCell)`
  width: 72px;
  padding-right: 12px;
  text-align: right;
`;
